// import React, { useState, useEffect } from 'react';
// import { FiSearch, FiPlus, FiEdit2, FiTrash2, FiUser, FiHash, FiFileText, FiSliders, FiCheck, FiRefreshCw } from 'react-icons/fi';
// import { message } from 'antd';
// import { getAccessToken } from '../../token';
// import { API_URL } from '../../Constants';

// const FormInput = ({ label, icon: Icon, ...props }) => (
//   <div className="mb-4">
//     <label className="block text-gray-700 font-medium mb-1">{label}</label>
//     <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 bg-white">
//       {Icon && <Icon className="text-gray-500 mr-2" />}
//       <input className="w-full outline-none bg-transparent" {...props} />
//     </div>
//   </div>
// );

// // NEW: Component for Multiple Checkbox Selection
// const FormCheckboxGroup = ({ label, icon: Icon, options, selectedValues, onChange }) => (
//   <div className="mb-4 col-span-2">
//     <label className="block text-gray-700 font-medium mb-2 flex items-center">
//       {Icon && <Icon className="text-gray-500 mr-2" />}
//       {label}
//     </label>
//     <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-h-40 overflow-y-auto p-3 border border-gray-300 rounded-lg bg-white">
//       {options.length === 0 ? (
//         <p className="text-sm text-gray-400 col-span-full">No Sender IDs available.</p>
//       ) : (
//         options.map((opt) => (
//           <label key={opt.value} className="flex items-center space-x-2 cursor-pointer hover:bg-gray-50 p-1 rounded">
//             <input
//               type="checkbox"
//               value={opt.value}
//               checked={selectedValues.includes(opt.value)}
//               onChange={(e) => {
//                 const checked = e.target.checked;
//                 const value = opt.value;
//                 const newValues = checked
//                   ? [...selectedValues, value]
//                   : selectedValues.filter((v) => v !== value);
//                 onChange(newValues);
//               }}
//               className="rounded text-[#0C4550] focus:ring-[#0C4550] w-4 h-4 cursor-pointer"
//             />
//             <span className="text-sm font-medium text-gray-700">{opt.label}</span>
//           </label>
//         ))
//       )}
//     </div>
//     {selectedValues.length === 0 && (
//       <p className="text-red-500 text-xs mt-1">Please select at least one Sender ID.</p>
//     )}
//   </div>
// );

// const FormTextArea = ({ label, icon: Icon, maxLength, value, ...props }) => (
//   <div className="mb-4 col-span-2">
//     <label className="block text-gray-700 font-medium mb-1">{label}</label>
//     <div className="flex items-start border border-gray-300 rounded-lg px-3 py-2 bg-white">
//       {Icon && <Icon className="text-gray-500 mr-2 mt-1" />}
//       <textarea {...props} value={value} className="w-full outline-none resize-none bg-transparent" maxLength={maxLength} rows={4} />
//     </div>
//     <div className="text-right text-xs text-gray-500 mt-1">{value?.length || 0}/{maxLength}</div>
//   </div>
// );

// const SuccessPopup = ({ isOpen, onClose, title, desc, icon: Icon, iconColor, iconBg }) => {
//   useEffect(() => {
//     if (isOpen) {
//       const timer = setTimeout(onClose, 3000);
//       return () => clearTimeout(timer);
//     }
//   }, [isOpen, onClose]);

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center z-50 animate-fadeIn">
//       <div className="bg-black/60 absolute inset-0" onClick={onClose}></div>
//       <div className="bg-[#f0EFEB] rounded-2xl p-8 max-w-sm mx-4 transform animate-scaleIn z-50 text-center shadow-2xl border border-[#0C4550]/20">
//         <div className={`w-16 h-16 ${iconBg} rounded-full flex items-center justify-center mx-auto mb-4 border`}>
//           <Icon className={`${iconColor} text-2xl`} />
//         </div>
//         <h3 className="text-xl font-bold text-[#0C4550] mb-2">{title}</h3>
//         <p className="text-gray-600 mb-6">{desc}</p>
//         <button onClick={onClose} className="w-full px-6 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-bold text-sm hover:bg-[#0A3A43]">
//           Continue
//         </button>
//       </div>
//     </div>
//   );
// };

// export const Templates = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [templates, setTemplates] = useState([]);
  
//   const [isEditing, setIsEditing] = useState(false);
//   const [editingTemplateData, setEditingTemplateData] = useState(null);
  
//   const [loading, setLoading] = useState(false);
//   const [senders, setSenders] = useState([]);
  
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [popupContent, setPopupContent] = useState({});

//   const token = getAccessToken();

//   // UPDATED: Use an array for senderIds
//   const [templateForm, setTemplateForm] = useState({
//     senderIds: [],
//     templateId: '',
//     content: ''
//   });

//   useEffect(() => {
//     fetchTemplates();
//     fetchSenders();
//   }, []);

//   const fetchTemplates = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(`${API_URL}/api/dlt/templates`, {
//         headers: { 'Authorization': `Bearer ${token}` }
//       });
//       if (res.ok) setTemplates(await res.json());
//     } catch (error) {
//       message.error('Failed to load templates');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchSenders = async () => {
//     try {
//       const res = await fetch(`${API_URL}/api/dlt/sender-ids`, {
//         headers: { 'Authorization': `Bearer ${token}` }
//       });
//       if (res.ok) {
//         const data = await res.json();
//         setSenders(data.map(s => ({ value: s.header, label: s.header })));
//       }
//     } catch (error) {}
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setTemplateForm(prev => ({ ...prev, [name]: value }));
//   };

//   // CREATE OR UPDATE TEMPLATE
//   const handleSubmitTemplate = async (e) => {
//     e.preventDefault();

//     // UPDATED validation to check array length
//     if (templateForm.senderIds.length === 0 || !templateForm.templateId || !templateForm.content) {
//       return message.error('Please fill in all required fields and select at least one Sender ID');
//     }

//     try {
//       setLoading(true);
//       const url = isEditing 
//         ? `${API_URL}/api/dlt/templates/${editingTemplateData.templateId}`
//         : `${API_URL}/api/dlt/templates`;
      
//       const method = isEditing ? 'PUT' : 'POST';

//       const res = await fetch(url, {
//         method: method,
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(templateForm), 
//       });

//       if (!res.ok) throw new Error((await res.json()).message || 'Failed to save template');

//       await fetchTemplates();
//       handleCloseModal();
      
//       setPopupContent({
//           title: isEditing ? "Template Updated!" : "Template Saved!",
//           desc: isEditing ? "Your template modifications were saved." : "Your DLT template is securely registered.",
//           icon: isEditing ? FiRefreshCw : FiCheck,
//           iconBg: isEditing ? "bg-blue-100 border-blue-200" : "bg-emerald-100 border-emerald-200",
//           iconColor: isEditing ? "text-blue-600" : "text-emerald-600"
//       });
//       setShowSuccessPopup(true);
//     } catch (error) {
//       message.error(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditTemplate = (template) => {
//     setIsEditing(true);
//     setEditingTemplateData(template);
//     // UPDATED to pre-populate array properly
//     setTemplateForm({
//       senderIds: template.senderIds || [],
//       templateId: template.templateId, 
//       content: template.content || ''
//     });
//     setIsModalOpen(true);
//   };

//   const handleDelete = async (templateId) => {
//     if (!window.confirm(`Are you sure you want to delete template ${templateId}?`)) return;
//     try {
//       const res = await fetch(`${API_URL}/api/dlt/templates/${templateId}`, {
//         method: 'DELETE',
//         headers: { 'Authorization': `Bearer ${token}` }
//       });
//       if (res.ok) {
//         setTemplates(prev => prev.filter(t => t.templateId !== templateId));
//         message.success('Template deleted!');
//       }
//     } catch (error) {
//       message.error("Network error.");
//     }
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setIsEditing(false);
//     setEditingTemplateData(null);
//     setTemplateForm({ senderIds: [], templateId: '', content: '' });
//   };

//   // UPDATED Search logic to check array of sender IDs
//   const filteredTemplates = templates.filter(t =>
//     (t.senderIds && t.senderIds.some(id => id.toLowerCase().includes(searchTerm.toLowerCase()))) ||
//     t.templateId?.includes(searchTerm)
//   );

//   return (
//     <div className="min-h-screen bg-[#f0EFEB] p-6 font-sans">
//       <div className="max-w-7xl mx-auto">

//         {/* Header Section */}
//         <div className="mb-8 flex items-center justify-between">
//             <div className="flex items-center gap-4">
//                 <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center border border-[#0C4550]/30 shadow-sm">
//                     <span className="text-[#0C4550] font-bold text-[24px]">T</span>
//                 </div>
//                 <div>
//                 <h1 className="text-3xl font-bold text-[#0C4550]">My Templates</h1>
//                 <p className="text-medium text-gray-600 mt-1 flex items-center gap-2">
//                     <FiSliders size={14} /> Manage DLT approved SMS templates
//                 </p>
//                 </div>
//             </div>
            
//             <button
//               onClick={() => setIsModalOpen(true)}
//               className="flex items-center gap-2 px-6 py-3.5 bg-[#0C4550] text-white rounded-xl font-bold transition-all hover:bg-[#0A3A43] hover:scale-[1.02]"
//             >
//               <FiPlus size={18} />
//               <span>Create Template</span>
//             </button>
//         </div>

//         {/* Search Bar */}
//         <div className="mb-6 max-w-md relative">
//           <FiSearch className="absolute left-3 top-3 text-gray-400" />
//           <input 
//             type="text" 
//             placeholder="Search by Sender ID or Template ID..."
//             className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 outline-none focus:border-[#0C4550]"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </div>

//         {/* Templates Table */}
//         <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
//             <table className="w-full text-left">
//               <thead className="bg-[#0C4550]/5 border-b border-gray-200 text-xs font-bold text-[#0C4550] uppercase tracking-wider">
//                 <tr>
//                   <th className="py-4 px-6">Sender IDs</th>
//                   <th className="py-4 px-3">Template ID</th>
//                   <th className="py-4 px-3">Message</th>
//                   <th className="text-center py-4 px-3 w-32">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100">
//                 {filteredTemplates.map((template) => (
//                     <tr key={template.templateId} className="hover:bg-gray-50 transition-all">
//                       <td className="py-4 px-6 font-semibold text-[#0C4550]">
//                         {/* Display comma separated List of IDs with a badge styling */}
//                         <div className="flex flex-wrap gap-1">
//                           {template.senderIds?.map(id => (
//                             <span key={id} className="bg-[#0C4550]/10 text-[#0C4550] text-xs px-2 py-1 rounded">
//                               {id}
//                             </span>
//                           ))}
//                         </div>
//                       </td>
//                       <td className="py-4 px-3 font-mono text-sm text-gray-600 bg-gray-50 rounded">{template.templateId}</td>
//                       <td className="py-4 px-3 text-sm text-gray-600 truncate max-w-xs">{template.content}</td>
//                       <td className="py-4 px-3 text-center flex justify-center gap-2">
//                         <button onClick={() => handleEditTemplate(template)} className="p-2 text-[#0C4550] hover:bg-gray-100 rounded-lg">
//                           <FiEdit2 size={16} />
//                         </button>
//                         <button onClick={() => handleDelete(template.templateId)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg">
//                           <FiTrash2 size={16} />
//                         </button>
//                       </td>
//                     </tr>
//                 ))}
//               </tbody>
//             </table>
//         </div>

//         {/* Create/Edit Modal */}
//         {isModalOpen && (
//           <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fadeIn">
//             <div className="bg-[#f0EFEB] rounded-2xl w-full max-w-2xl transform border border-[#0C4550]/20 shadow-2xl">
//               <div className="px-8 py-6 bg-[#0C4550] rounded-t-2xl">
//                 <h2 className="text-xl font-bold text-white">{isEditing ? 'Edit Template Details' : 'Add DLT Template'}</h2>
//               </div>

//               <form onSubmit={handleSubmitTemplate} className="p-8 space-y-6">
//                 <div className="space-y-4 bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                  
//                   {/* Template ID Full Width */}
//                   <FormInput
//                     label="Template ID"
//                     name="templateId"
//                     value={templateForm.templateId}
//                     onChange={handleInputChange}
//                     placeholder="e.g. 1207161900000000001"
//                     icon={FiHash}
//                     required
//                   />

//                   {/* Multiple Sender IDs Selection */}
//                   <FormCheckboxGroup
//                     label="Linked Sender IDs"
//                     icon={FiUser}
//                     options={senders}
//                     selectedValues={templateForm.senderIds}
//                     onChange={(newValues) => setTemplateForm(prev => ({ ...prev, senderIds: newValues }))}
//                   />

//                   {/* Content Texture full width */}
//                   <FormTextArea
//                     label="Approved Content"
//                     name="content"
//                     value={templateForm.content}
//                     onChange={handleInputChange}
//                     placeholder="Enter template content. Use {#var#} for variables."
//                     icon={FiFileText}
//                     required
//                     maxLength={1000}
//                   />
//                 </div>

//                 <div className="flex gap-3">
//                   <button type="button" onClick={handleCloseModal} className="flex-1 py-3 text-gray-700 bg-white border rounded-xl font-semibold hover:bg-gray-50">
//                     Cancel
//                   </button>
//                   <button type="submit" disabled={loading} className="flex-1 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-medium disabled:opacity-50">
//                     {loading ? 'Processing...' : (isEditing ? 'Update Template' : 'Save Template')}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}

//         <SuccessPopup isOpen={showSuccessPopup} onClose={() => setShowSuccessPopup(false)} {...popupContent} />
//       </div>
//     </div>
//   );
// };





// import React, { useState, useEffect } from 'react';
// import { FiSearch, FiPlus, FiEdit2, FiTrash2, FiUser, FiHash, FiFileText, FiSliders, FiCheck, FiRefreshCw, FiTag } from 'react-icons/fi';
// import { message } from 'antd';
// import { getAccessToken } from '../../token';
// import { API_URL } from '../../Constants';

// const FormInput = ({ label, icon: Icon, ...props }) => (
//   <div className="mb-4">
//     <label className="block text-gray-700 font-medium mb-1">{label}</label>
//     <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 bg-white">
//       {Icon && <Icon className="text-gray-500 mr-2" />}
//       <input className="w-full outline-none bg-transparent" {...props} />
//     </div>
//   </div>
// );

// // Component for Multiple Checkbox Selection
// const FormCheckboxGroup = ({ label, icon: Icon, options, selectedValues, onChange }) => (
//   <div className="mb-4 col-span-2">
//     <label className="block text-gray-700 font-medium mb-2 flex items-center">
//       {Icon && <Icon className="text-gray-500 mr-2" />}
//       {label}
//     </label>
//     <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-h-40 overflow-y-auto p-3 border border-gray-300 rounded-lg bg-white">
//       {options.length === 0 ? (
//         <p className="text-sm text-gray-400 col-span-full">No Sender IDs available.</p>
//       ) : (
//         options.map((opt) => (
//           <label key={opt.value} className="flex items-center space-x-2 cursor-pointer hover:bg-gray-50 p-1 rounded">
//             <input
//               type="checkbox"
//               value={opt.value}
//               checked={selectedValues.includes(opt.value)}
//               onChange={(e) => {
//                 const checked = e.target.checked;
//                 const value = opt.value;
//                 const newValues = checked
//                   ? [...selectedValues, value]
//                   : selectedValues.filter((v) => v !== value);
//                 onChange(newValues);
//               }}
//               className="rounded text-[#0C4550] focus:ring-[#0C4550] w-4 h-4 cursor-pointer"
//             />
//             <span className="text-sm font-medium text-gray-700">{opt.label}</span>
//           </label>
//         ))
//       )}
//     </div>
//     {selectedValues.length === 0 && (
//       <p className="text-red-500 text-xs mt-1">Please select at least one Sender ID.</p>
//     )}
//   </div>
// );

// const FormTextArea = ({ label, icon: Icon, maxLength, value, ...props }) => (
//   <div className="mb-4 col-span-2">
//     <label className="block text-gray-700 font-medium mb-1">{label}</label>
//     <div className="flex items-start border border-gray-300 rounded-lg px-3 py-2 bg-white">
//       {Icon && <Icon className="text-gray-500 mr-2 mt-1" />}
//       <textarea {...props} value={value} className="w-full outline-none resize-none bg-transparent" maxLength={maxLength} rows={4} />
//     </div>
//     <div className="text-right text-xs text-gray-500 mt-1">{value?.length || 0}/{maxLength}</div>
//   </div>
// );

// const SuccessPopup = ({ isOpen, onClose, title, desc, icon: Icon, iconColor, iconBg }) => {
//   useEffect(() => {
//     if (isOpen) {
//       const timer = setTimeout(onClose, 3000);
//       return () => clearTimeout(timer);
//     }
//   }, [isOpen, onClose]);

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center z-50 animate-fadeIn">
//       <div className="bg-black/60 absolute inset-0" onClick={onClose}></div>
//       <div className="bg-[#f0EFEB] rounded-2xl p-8 max-w-sm mx-4 transform animate-scaleIn z-50 text-center shadow-2xl border border-[#0C4550]/20">
//         <div className={`w-16 h-16 ${iconBg} rounded-full flex items-center justify-center mx-auto mb-4 border`}>
//           <Icon className={`${iconColor} text-2xl`} />
//         </div>
//         <h3 className="text-xl font-bold text-[#0C4550] mb-2">{title}</h3>
//         <p className="text-gray-600 mb-6">{desc}</p>
//         <button onClick={onClose} className="w-full px-6 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-bold text-sm hover:bg-[#0A3A43]">
//           Continue
//         </button>
//       </div>
//     </div>
//   );
// };

// export const Templates = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [templates, setTemplates] = useState([]);
  
//   const [isEditing, setIsEditing] = useState(false);
//   const [editingTemplateData, setEditingTemplateData] = useState(null);
  
//   const [loading, setLoading] = useState(false);
//   const [senders, setSenders] = useState([]);
  
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [popupContent, setPopupContent] = useState({});

//   const token = getAccessToken();

//   // UPDATED: Added templateName to form state
//   const [templateForm, setTemplateForm] = useState({
//     senderIds: [],
//     templateName: '',
//     templateId: '',
//     content: ''
//   });

//   useEffect(() => {
//     fetchTemplates();
//     fetchSenders();
//   }, []);

//   const fetchTemplates = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(`${API_URL}/api/dlt/templates`, {
//         headers: { 'Authorization': `Bearer ${token}` }
//       });
//       if (res.ok) setTemplates(await res.json());
//     } catch (error) {
//       message.error('Failed to load templates');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchSenders = async () => {
//     try {
//       const res = await fetch(`${API_URL}/api/dlt/sender-ids`, {
//         headers: { 'Authorization': `Bearer ${token}` }
//       });
//       if (res.ok) {
//         const data = await res.json();
//         setSenders(data.map(s => ({ value: s.header, label: s.header })));
//       }
//     } catch (error) {}
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setTemplateForm(prev => ({ ...prev, [name]: value }));
//   };

//   // CREATE OR UPDATE TEMPLATE
//   const handleSubmitTemplate = async (e) => {
//     e.preventDefault();

//     // UPDATED validation to include templateName
//     if (templateForm.senderIds.length === 0 || !templateForm.templateName || !templateForm.templateId || !templateForm.content) {
//       return message.error('Please fill in all required fields and select at least one Sender ID');
//     }

//     try {
//       setLoading(true);
//       const url = isEditing 
//         ? `${API_URL}/api/dlt/templates/${editingTemplateData.templateId}`
//         : `${API_URL}/api/dlt/templates`;
      
//       const method = isEditing ? 'PUT' : 'POST';

//       const res = await fetch(url, {
//         method: method,
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(templateForm), // templateName is automatically included here
//       });

//       if (!res.ok) throw new Error((await res.json()).message || 'Failed to save template');

//       await fetchTemplates();
//       handleCloseModal();
      
//       setPopupContent({
//           title: isEditing ? "Template Updated!" : "Template Saved!",
//           desc: isEditing ? "Your template modifications were saved." : "Your DLT template is securely registered.",
//           icon: isEditing ? FiRefreshCw : FiCheck,
//           iconBg: isEditing ? "bg-blue-100 border-blue-200" : "bg-emerald-100 border-emerald-200",
//           iconColor: isEditing ? "text-blue-600" : "text-emerald-600"
//       });
//       setShowSuccessPopup(true);
//     } catch (error) {
//       message.error(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditTemplate = (template) => {
//     setIsEditing(true);
//     setEditingTemplateData(template);
//     // UPDATED to pre-populate templateName
//     setTemplateForm({
//       senderIds: template.senderIds || [],
//       templateName: template.templateName || '',
//       templateId: template.templateId, 
//       content: template.content || ''
//     });
//     setIsModalOpen(true);
//   };

//   const handleDelete = async (templateId) => {
//     if (!window.confirm(`Are you sure you want to delete template ${templateId}?`)) return;
//     try {
//       const res = await fetch(`${API_URL}/api/dlt/templates/${templateId}`, {
//         method: 'DELETE',
//         headers: { 'Authorization': `Bearer ${token}` }
//       });
//       if (res.ok) {
//         setTemplates(prev => prev.filter(t => t.templateId !== templateId));
//         message.success('Template deleted!');
//       }
//     } catch (error) {
//       message.error("Network error.");
//     }
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setIsEditing(false);
//     setEditingTemplateData(null);
//     // UPDATED to clear templateName
//     setTemplateForm({ senderIds: [], templateName: '', templateId: '', content: '' });
//   };

//   // UPDATED Search logic to also search by templateName
//   const filteredTemplates = templates.filter(t =>
//     (t.senderIds && t.senderIds.some(id => id.toLowerCase().includes(searchTerm.toLowerCase()))) ||
//     t.templateId?.includes(searchTerm) ||
//     (t.templateName && t.templateName.toLowerCase().includes(searchTerm.toLowerCase()))
//   );

//   return (
//     <div className="min-h-screen bg-[#f0EFEB] p-6 font-sans">
//       <div className="max-w-7xl mx-auto">

//         {/* Header Section */}
//         <div className="mb-8 flex items-center justify-between">
//             <div className="flex items-center gap-4">
//                 <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center border border-[#0C4550]/30 shadow-sm">
//                     <span className="text-[#0C4550] font-bold text-[24px]">T</span>
//                 </div>
//                 <div>
//                 <h1 className="text-3xl font-bold text-[#0C4550]">My Templates</h1>
//                 <p className="text-medium text-gray-600 mt-1 flex items-center gap-2">
//                     <FiSliders size={14} /> Manage DLT approved SMS templates
//                 </p>
//                 </div>
//             </div>
            
//             <button
//               onClick={() => setIsModalOpen(true)}
//               className="flex items-center gap-2 px-6 py-3.5 bg-[#0C4550] text-white rounded-xl font-bold transition-all hover:bg-[#0A3A43] hover:scale-[1.02]"
//             >
//               <FiPlus size={18} />
//               <span>Create Template</span>
//             </button>
//         </div>

//         {/* Search Bar */}
//         <div className="mb-6 max-w-md relative">
//           <FiSearch className="absolute left-3 top-3 text-gray-400" />
//           <input 
//             type="text" 
//             placeholder="Search by Name, Sender ID, or Template ID..."
//             className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 outline-none focus:border-[#0C4550]"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </div>

//         {/* Templates Table */}
//         <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
//             <table className="w-full text-left">
//               <thead className="bg-[#0C4550]/5 border-b border-gray-200 text-xs font-bold text-[#0C4550] uppercase tracking-wider">
//                 <tr>
//                   <th className="py-4 px-6">Sender IDs</th>
//                   {/* NEW COLUMN */}
//                   <th className="py-4 px-3">Template Name</th>
//                   <th className="py-4 px-3">Template ID</th>
//                   <th className="py-4 px-3">Message</th>
//                   <th className="text-center py-4 px-3 w-32">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100">
//                 {filteredTemplates.map((template) => (
//                     <tr key={template.templateId} className="hover:bg-gray-50 transition-all">
//                       <td className="py-4 px-6 font-semibold text-[#0C4550]">
//                         <div className="flex flex-wrap gap-1">
//                           {template.senderIds?.map(id => (
//                             <span key={id} className="bg-[#0C4550]/10 text-[#0C4550] text-xs px-2 py-1 rounded">
//                               {id}
//                             </span>
//                           ))}
//                         </div>
//                       </td>
//                       {/* DISPLAY TEMPLATE NAME */}
//                       <td className="py-4 px-3 font-semibold text-gray-800">{template.templateName}</td>
//                       <td className="py-4 px-3 font-mono text-sm text-gray-600 bg-gray-50 rounded">{template.templateId}</td>
//                       <td className="py-4 px-3 text-sm text-gray-600 truncate max-w-xs">{template.content}</td>
//                       <td className="py-4 px-3 text-center flex justify-center gap-2">
//                         <button onClick={() => handleEditTemplate(template)} className="p-2 text-[#0C4550] hover:bg-gray-100 rounded-lg">
//                           <FiEdit2 size={16} />
//                         </button>
//                         <button onClick={() => handleDelete(template.templateId)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg">
//                           <FiTrash2 size={16} />
//                         </button>
//                       </td>
//                     </tr>
//                 ))}
//               </tbody>
//             </table>
            
//             {filteredTemplates.length === 0 && (
//               <div className="text-center py-10 text-gray-500">
//                 No templates found.
//               </div>
//             )}
//         </div>

//         {/* Create/Edit Modal */}
//         {isModalOpen && (
//           <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fadeIn">
//             <div className="bg-[#f0EFEB] rounded-2xl w-full max-w-2xl transform border border-[#0C4550]/20 shadow-2xl">
//               <div className="px-8 py-6 bg-[#0C4550] rounded-t-2xl">
//                 <h2 className="text-xl font-bold text-white">{isEditing ? 'Edit Template Details' : 'Add DLT Template'}</h2>
//               </div>

//               <form onSubmit={handleSubmitTemplate} className="p-8 space-y-6">
//                 <div className="space-y-4 bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                  
//                   {/* NEW: Template Name Input */}
//                   <FormInput
//                     label="Template Name"
//                     name="templateName"
//                     value={templateForm.templateName}
//                     onChange={handleInputChange}
//                     placeholder="e.g. OTP_Verification"
//                     icon={FiTag}
//                     required
//                   />

//                   {/* Template ID Full Width */}
//                   <FormInput
//                     label="DLT Template ID"
//                     name="templateId"
//                     value={templateForm.templateId}
//                     onChange={handleInputChange}
//                     placeholder="e.g. 1207161900000000001"
//                     icon={FiHash}
//                     required
//                   />

//                   {/* Multiple Sender IDs Selection */}
//                   <FormCheckboxGroup
//                     label="Linked Sender IDs"
//                     icon={FiUser}
//                     options={senders}
//                     selectedValues={templateForm.senderIds}
//                     onChange={(newValues) => setTemplateForm(prev => ({ ...prev, senderIds: newValues }))}
//                   />

//                   {/* Content Texture full width */}
//                   <FormTextArea
//                     label="Approved Content"
//                     name="content"
//                     value={templateForm.content}
//                     onChange={handleInputChange}
//                     placeholder="Enter template content. Use {#var#} for variables."
//                     icon={FiFileText}
//                     required
//                     maxLength={1000}
//                   />
//                 </div>

//                 <div className="flex gap-3">
//                   <button type="button" onClick={handleCloseModal} className="flex-1 py-3 text-gray-700 bg-white border rounded-xl font-semibold hover:bg-gray-50">
//                     Cancel
//                   </button>
//                   <button type="submit" disabled={loading} className="flex-1 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-medium disabled:opacity-50 flex justify-center items-center gap-2">
//                     {loading && <FiRefreshCw className="animate-spin" />}
//                     {isEditing ? 'Update Template' : 'Save Template'}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}

//         <SuccessPopup isOpen={showSuccessPopup} onClose={() => setShowSuccessPopup(false)} {...popupContent} />
//       </div>
//     </div>
//   );
// };





import React, { useState, useEffect } from 'react';
import { FiSearch, FiPlus, FiEdit2, FiTrash2, FiUser, FiHash, FiFileText, FiSliders, FiCheck, FiRefreshCw, FiTag, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { message } from 'antd';
import { getAccessToken } from '../../token';
import { API_URL } from '../../Constants';

const FormInput = ({ label, icon: Icon, ...props }) => (
  <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-1">{label}</label>
    <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 bg-white">
      {Icon && <Icon className="text-gray-500 mr-2" />}
      <input className="w-full outline-none bg-transparent" {...props} />
    </div>
  </div>
);

const FormCheckboxGroup = ({ label, icon: Icon, options, selectedValues, onChange }) => (
  <div className="mb-4 col-span-2">
    <label className="block text-gray-700 font-medium mb-2 flex items-center">
      {Icon && <Icon className="text-gray-500 mr-2" />}
      {label}
    </label>
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-h-40 overflow-y-auto p-3 border border-gray-300 rounded-lg bg-white">
      {options.length === 0 ? (
        <p className="text-sm text-gray-400 col-span-full">No Sender IDs available.</p>
      ) : (
        options.map((opt) => (
          <label key={opt.value} className="flex items-center space-x-2 cursor-pointer hover:bg-gray-50 p-1 rounded">
            <input
              type="checkbox"
              value={opt.value}
              checked={selectedValues.includes(opt.value)}
              onChange={(e) => {
                const checked = e.target.checked;
                const value = opt.value;
                const newValues = checked
                  ? [...selectedValues, value]
                  : selectedValues.filter((v) => v !== value);
                onChange(newValues);
              }}
              className="rounded text-[#0C4550] focus:ring-[#0C4550] w-4 h-4 cursor-pointer"
            />
            <span className="text-sm font-medium text-gray-700">{opt.label}</span>
          </label>
        ))
      )}
    </div>
    {selectedValues.length === 0 && (
      <p className="text-red-500 text-xs mt-1">Please select at least one Sender ID.</p>
    )}
  </div>
);

const FormTextArea = ({ label, icon: Icon, maxLength, value, ...props }) => (
  <div className="mb-4 col-span-2">
    <label className="block text-gray-700 font-medium mb-1">{label}</label>
    <div className="flex items-start border border-gray-300 rounded-lg px-3 py-2 bg-white">
      {Icon && <Icon className="text-gray-500 mr-2 mt-1" />}
      <textarea {...props} value={value} className="w-full outline-none resize-none bg-transparent" maxLength={maxLength} rows={4} />
    </div>
    <div className="text-right text-xs text-gray-500 mt-1">{value?.length || 0}/{maxLength}</div>
  </div>
);

const SuccessPopup = ({ isOpen, onClose, title, desc, icon: Icon, iconColor, iconBg }) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(onClose, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 animate-fadeIn">
      <div className="bg-black/60 absolute inset-0" onClick={onClose}></div>
      <div className="bg-[#f0EFEB] rounded-2xl p-8 max-w-sm mx-4 transform animate-scaleIn z-50 text-center shadow-2xl border border-[#0C4550]/20">
        <div className={`w-16 h-16 ${iconBg} rounded-full flex items-center justify-center mx-auto mb-4 border`}>
          <Icon className={`${iconColor} text-2xl`} />
        </div>
        <h3 className="text-xl font-bold text-[#0C4550] mb-2">{title}</h3>
        <p className="text-gray-600 mb-6">{desc}</p>
        <button onClick={onClose} className="w-full px-6 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-bold text-sm hover:bg-[#0A3A43]">
          Continue
        </button>
      </div>
    </div>
  );
};

export const Templates = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [templates, setTemplates] = useState([]);
  
  const [isEditing, setIsEditing] = useState(false);
  const [editingTemplateData, setEditingTemplateData] = useState(null);
  
  const [loading, setLoading] = useState(false);
  const [senders, setSenders] = useState([]);
  
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({});

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const token = getAccessToken();

  const [templateForm, setTemplateForm] = useState({
    senderIds: [],
    templateName: '',
    templateId: '',
    content: ''
  });

  useEffect(() => {
    fetchTemplates();
    fetchSenders();
  }, []);

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/dlt/templates`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        // SORTING LOGIC: Show newest first (assuming the API returns objects with an ID or date we can sort by, 
        // otherwise, we just reverse the array if the backend appends new items to the end).
        setTemplates(data.reverse()); 
      }
    } catch (error) {
      message.error('Failed to load templates');
    } finally {
      setLoading(false);
    }
  };

  const fetchSenders = async () => {
    try {
      const res = await fetch(`${API_URL}/api/dlt/sender-ids`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setSenders(data.map(s => ({ value: s.header, label: s.header })));
      }
    } catch (error) {}
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTemplateForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmitTemplate = async (e) => {
    e.preventDefault();

    if (templateForm.senderIds.length === 0 || !templateForm.templateName || !templateForm.templateId || !templateForm.content) {
      return message.error('Please fill in all required fields and select at least one Sender ID');
    }

    try {
      setLoading(true);
      const url = isEditing 
        ? `${API_URL}/api/dlt/templates/${editingTemplateData.templateId}`
        : `${API_URL}/api/dlt/templates`;
      
      const method = isEditing ? 'PUT' : 'POST';

      const res = await fetch(url, {
        method: method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(templateForm),
      });

      if (!res.ok) throw new Error((await res.json()).message || 'Failed to save template');

      await fetchTemplates();
      setCurrentPage(1); // Go to page 1 to see the new entry
      handleCloseModal();
      
      setPopupContent({
          title: isEditing ? "Template Updated!" : "Template Saved!",
          desc: isEditing ? "Your template modifications were saved." : "Your DLT template is securely registered.",
          icon: isEditing ? FiRefreshCw : FiCheck,
          iconBg: isEditing ? "bg-blue-100 border-blue-200" : "bg-emerald-100 border-emerald-200",
          iconColor: isEditing ? "text-blue-600" : "text-emerald-600"
      });
      setShowSuccessPopup(true);
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEditTemplate = (template) => {
    setIsEditing(true);
    setEditingTemplateData(template);
    setTemplateForm({
      senderIds: template.senderIds || [],
      templateName: template.templateName || '',
      templateId: template.templateId, 
      content: template.content || ''
    });
    setIsModalOpen(true);
  };

  const handleDelete = async (templateId) => {
    if (!window.confirm(`Are you sure you want to delete template ${templateId}?`)) return;
    try {
      const res = await fetch(`${API_URL}/api/dlt/templates/${templateId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        setTemplates(prev => prev.filter(t => t.templateId !== templateId));
        message.success('Template deleted!');
      }
    } catch (error) {
      message.error("Network error.");
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsEditing(false);
    setEditingTemplateData(null);
    setTemplateForm({ senderIds: [], templateName: '', templateId: '', content: '' });
  };

  const filteredTemplates = templates.filter(t =>
    (t.senderIds && t.senderIds.some(id => id.toLowerCase().includes(searchTerm.toLowerCase()))) ||
    t.templateId?.includes(searchTerm) ||
    (t.templateName && t.templateName.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTemplates = filteredTemplates.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredTemplates.length / itemsPerPage);

  return (
    <div className="min-h-screen bg-[#f0EFEB] p-6 font-sans">
      <div className="max-w-7xl mx-auto">

        {/* Header Section */}
        <div className="mb-8 flex items-center justify-between">
            <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center border border-[#0C4550]/30 shadow-sm">
                    <span className="text-[#0C4550] font-bold text-[24px]">T</span>
                </div>
                <div>
                <h1 className="text-3xl font-bold text-[#0C4550]">My Templates</h1>
                <p className="text-medium text-gray-600 mt-1 flex items-center gap-2">
                    <FiSliders size={14} /> Manage DLT approved SMS templates
                </p>
                </div>
            </div>
            
            <button
              onClick={() => setIsModalOpen(true)}
              className="flex items-center gap-2 px-6 py-3.5 bg-[#0C4550] text-white rounded-xl font-bold transition-all hover:bg-[#0A3A43] hover:scale-[1.02]"
            >
              <FiPlus size={18} />
              <span>Create Template</span>
            </button>
        </div>

        {/* Search Bar */}
        <div className="mb-6 max-w-md relative">
          <FiSearch className="absolute left-3 top-3 text-gray-400" />
          <input 
            type="text" 
            placeholder="Search by Name, Sender ID, or Template ID..."
            className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 outline-none focus:border-[#0C4550]"
            value={searchTerm}
            onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // Reset to page 1 when searching
            }}
          />
        </div>

        {/* Templates Table */}
        <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
            <table className="w-full text-left">
              <thead className="bg-[#0C4550]/5 border-b border-gray-200 text-xs font-bold text-[#0C4550] uppercase tracking-wider">
                <tr>
                  <th className="py-4 px-6">Sender IDs</th>
                  <th className="py-4 px-3">Template Name</th>
                  <th className="py-4 px-3">Template ID</th>
                  <th className="py-4 px-3">Message</th>
                  <th className="text-center py-4 px-3 w-32">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {currentTemplates.map((template) => (
                    <tr key={template.templateId} className="hover:bg-gray-50 transition-all">
                      <td className="py-4 px-6 font-semibold text-[#0C4550]">
                        <div className="flex flex-wrap gap-1">
                          {template.senderIds?.map(id => (
                            <span key={id} className="bg-[#0C4550]/10 text-[#0C4550] text-xs px-2 py-1 rounded">
                              {id}
                            </span>
                          ))}
                        </div>
                      </td>
                      <td className="py-4 px-3 font-semibold text-gray-800">{template.templateName}</td>
                      <td className="py-4 px-3 font-mono text-sm text-gray-600 bg-gray-50 rounded">{template.templateId}</td>
                      <td className="py-4 px-3 text-sm text-gray-600 truncate max-w-xs">{template.content}</td>
                      <td className="py-4 px-3 text-center flex justify-center gap-2">
                        <button onClick={() => handleEditTemplate(template)} className="p-2 text-[#0C4550] hover:bg-gray-100 rounded-lg">
                          <FiEdit2 size={16} />
                        </button>
                        <button onClick={() => handleDelete(template.templateId)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg">
                          <FiTrash2 size={16} />
                        </button>
                      </td>
                    </tr>
                ))}
              </tbody>
            </table>
            
            {filteredTemplates.length === 0 && (
              <div className="text-center py-10 text-gray-500">
                No templates found.
              </div>
            )}

            {/* Pagination Controls */}
            {filteredTemplates.length > 0 && (
              <div className="px-6 py-4 bg-white border-t border-gray-100 flex items-center justify-between">
                <div className="text-sm text-gray-500">
                    Showing <span className="font-medium text-gray-700">{indexOfFirstItem + 1}</span> to <span className="font-medium text-gray-700">{Math.min(indexOfLastItem, filteredTemplates.length)}</span> of <span className="font-medium text-gray-700">{filteredTemplates.length}</span> results
                </div>
                <div className="flex items-center gap-2">
                    <button 
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="p-2 border rounded-lg hover:bg-gray-50 disabled:opacity-30 transition-colors"
                    >
                        <FiChevronLeft />
                    </button>
                    {[...Array(totalPages)].map((_, i) => (
                        <button
                            key={i + 1}
                            onClick={() => setCurrentPage(i + 1)}
                            className={`w-8 h-8 rounded-lg text-sm font-medium transition-colors ${currentPage === i + 1 ? 'bg-[#0C4550] text-white' : 'text-gray-600 hover:bg-gray-100 border'}`}
                        >
                            {i + 1}
                        </button>
                    ))}
                    <button 
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className="p-2 border rounded-lg hover:bg-gray-50 disabled:opacity-30 transition-colors"
                    >
                        <FiChevronRight />
                    </button>
                </div>
              </div>
            )}
        </div>

        {/* Create/Edit Modal */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fadeIn">
            <div className="bg-[#f0EFEB] rounded-2xl w-full max-w-2xl transform border border-[#0C4550]/20 shadow-2xl">
              <div className="px-8 py-6 bg-[#0C4550] rounded-t-2xl">
                <h2 className="text-xl font-bold text-white">{isEditing ? 'Edit Template Details' : 'Add DLT Template'}</h2>
              </div>

              <form onSubmit={handleSubmitTemplate} className="p-8 space-y-6">
                <div className="space-y-4 bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                  <FormInput
                    label="Template Name"
                    name="templateName"
                    value={templateForm.templateName}
                    onChange={handleInputChange}
                    placeholder="e.g. OTP_Verification"
                    icon={FiTag}
                    required
                  />

                  <FormInput
                    label="DLT Template ID"
                    name="templateId"
                    value={templateForm.templateId}
                    onChange={handleInputChange}
                    placeholder="e.g. 1207161900000000001"
                    icon={FiHash}
                    required
                  />

                  <FormCheckboxGroup
                    label="Linked Sender IDs"
                    icon={FiUser}
                    options={senders}
                    selectedValues={templateForm.senderIds}
                    onChange={(newValues) => setTemplateForm(prev => ({ ...prev, senderIds: newValues }))}
                  />

                  <FormTextArea
                    label="Approved Content"
                    name="content"
                    value={templateForm.content}
                    onChange={handleInputChange}
                    placeholder="Enter template content. Use {#var#} for variables."
                    icon={FiFileText}
                    required
                    maxLength={1000}
                  />
                </div>

                <div className="flex gap-3">
                  <button type="button" onClick={handleCloseModal} className="flex-1 py-3 text-gray-700 bg-white border rounded-xl font-semibold hover:bg-gray-50">
                    Cancel
                  </button>
                  <button type="submit" disabled={loading} className="flex-1 py-3 bg-[#0C4550] text-[#C5F637] rounded-xl font-medium disabled:opacity-50 flex justify-center items-center gap-2">
                    {loading && <FiRefreshCw className="animate-spin" />}
                    {isEditing ? 'Update Template' : 'Save Template'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        <SuccessPopup isOpen={showSuccessPopup} onClose={() => setShowSuccessPopup(false)} {...popupContent} />
      </div>
    </div>
  );
};